import React, { useEffect, useState } from "react";
import "./ResetPassword.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Notification } from "../../../../components/ToastNotification";
import { useAddResetPassMutation } from "../../../../Services/userApi";

const ResetPasswordForm = () => {
  const navigate = useNavigate();
  const { token } = useParams();

  const [password, setPassword] = useState("");

  // add user
  const [addResetPass, { error, data, isLoading }] = useAddResetPassMutation();
  useEffect(() => {
    if (data?.message) {
      Notification(data?.message, "success");
      navigate("/login");
    } else {
      Notification(error?.data?.message, "error");
    }
  }, [error, data, navigate]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    // Handle the reset logic here
    if (password.trim() === "") {
      Notification("Please enter your new password", "error");
      return;
    }
    const urlData = {
      token: token,
      password: password,
    };
    console.log("Resetting password to:", urlData);
    await addResetPass(urlData);
  };

  return (
    <div className="rp-wrapper">
      <div className="rp-content">
        {/* Title Section */}
        <h1 className="rp-title">Reset your Password?</h1>

        {/* Form Section */}
        <form className="rp-form" onSubmit={handleSubmit}>
          <label htmlFor="email" className="rp-label">
            New Password
          </label>

          <input
            type="password"
            id="password"
            className="rp-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <div className="rp-actions">
            <button type="submit" className="rp-btn" disabled={isLoading}>
              {isLoading ? "Sending..." : "Reset Password"}
            </button>

            <Link to="/login" className="rp-link">
              Back to login
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ResetPasswordForm;
